import queryString from 'query-string';
import qs from 'qs';

import api from 'src/configs/api';
import { TExpectedRevenue, TExpectedRevenueMember } from 'src/types/ExpectedRevenues/expectedRevenue.model';
import { TSaleClosingMember, TSalesClosing } from 'src/types/SalesClosing/salesClosing.model';
import { TAddMarketingFeeRequest, TMarketingFeeRequest } from 'src/types/Systems/marketingFee.model';
import {
  TFilterSocialDigitalMKRequest,
  TPostSetupAccountDigitalMK,
  TRequestCheckDuplicateMarketingSocial,
  TUpdateStatusParams
} from 'src/types/DigitalManagement/SetupDigitalMarketing/setupDigitalMarketing.model';
import { TFilterSocialPageRequest } from 'src/types/SocialPages/socialPage.model';
import {
  TAddMarketingFeeActualRequest,
  TMarketingFeeActualRequest,
  TMarketingFeeRequestParam,
  TUpdateStatusMarketingFeeActualParams
} from 'src/types/DigitalManagement/MarketingFeeActual/marketingFeeActual.model';
import { TFilterMarketingUserRequest, TUpdateMarketingUsername } from 'src/types/Systems/marketingUsername';
import { CommonSettings, TCommonSettingsRequest, TCurrencyRate } from 'src/types/Systems/settings.model';
import { TBaseRequestResponse } from 'src/types/Commons/baseApiRes.model';

const prefix = 'api/setting';

export async function postAddExpectedRevenue(data: TExpectedRevenue) {
  try {
    const res = await api.post(`${prefix}/expected-revenue`, data);
    return res.data;
  } catch (e: any) {
    return e?.response?.data;
  }
}

export async function getExpectedRevenue(param: TExpectedRevenueMember) {
  const query = qs.stringify(param);
  const res = await api.get(`${prefix}/get-expected-revenue?${query}`);
  return res.data;
}

export async function getSaleClosing(param: TSaleClosingMember) {
  const query = qs.stringify(param);
  const res = await api.get(`${prefix}/get-sales-closing?${query}`);
  return res.data;
}

export async function postAddSalesClosing(data: TSalesClosing) {
  try {
    const res = await api.post(`${prefix}/sales-closing`, data);
    return res.data;
  } catch (e: any) {
    return e?.response?.data;
  }
}

export async function getMarketingFee(param: TMarketingFeeRequest) {
  const query = queryString.stringify(param);
  const res = await api.get(`${prefix}/get-marketing-fee?${query}`);
  return res.data;
}

export async function addMarketingFee(data: TAddMarketingFeeRequest) {
  const res = await api.post(`${prefix}/marketing-fee`, data);
  return res.data;
}

export async function postAddSetupAccountDigitalMK(data: TPostSetupAccountDigitalMK) {
  try {
    const res = await api.post(`${prefix}/add-setup-account-digital`, data);
    return res.data;
  } catch (e: any) {
    return e?.response?.data;
  }
}

export async function getSetupAccountDigitalMK(userId: number) {
  const res = await api.get(`${prefix}/get-setup-account-digital?userId=${userId}`);
  return res.data;
}

export async function filterSocialDigitalML(param: TFilterSocialDigitalMKRequest) {
  const query = qs.stringify(param);
  const res = await api.get(`${prefix}/filter-social-account?${query}`);
  return res.data;
}

export async function postUpdateStatusSocialAccountDigitalMK(data: TUpdateStatusParams) {
  try {
    const res = await api.post(`${prefix}/update-status-social-account`, data);
    return res.data;
  } catch (e: any) {
    return e?.response?.data;
  }
}

export async function getUserAdsCostByUserId(param: TMarketingFeeActualRequest) {
  try {
    const query = queryString.stringify(param);
    const res = await api.get(`${prefix}/marketing-fee-actual?${query}`);
    return res.data;
  } catch (error: any) {
    return error?.response?.data;
  }
}

export async function postAddMarketingFeeActual(data: TAddMarketingFeeActualRequest) {
  const res = await api.post(`${prefix}/marketing-fee-actual`, data);
  return res.data;
}

export async function filterSocialPage(param: TFilterSocialPageRequest) {
  const query = qs.stringify(param);
  const res = await api.get(`${prefix}/social-page?${query}`);
  return res.data;
}

export const getMarketingReportByTeam = async (param: TMarketingFeeRequestParam) => {
  try {
    const query = queryString.stringify(param);
    const res = await api.get(`${prefix}/filter-marketing-fee-actual?${query}`);
    return res?.data;
  } catch (errors: any) {
    return errors?.response;
  }
};

export async function postUpdateStatusMarketingFeeActual(data: TUpdateStatusMarketingFeeActualParams) {
  try {
    const res = await api.post(`${prefix}/update-status-marketing-fee-actual`, data);
    return res.data;
  } catch (e: any) {
    return e?.response?.data;
  }
}

export async function filterMarketingUsernamePage(param: TFilterMarketingUserRequest) {
  const query = qs.stringify(param);
  const res = await api.get(`${prefix}/marketing-user?${query}`);
  return res.data;
}

export const putUpdateMarketingUsername = async (param: TUpdateMarketingUsername) => {
  try {
    const res = await api.put(`${prefix}/marketing-user/${param.orderId}`, param);
    return res.data;
  } catch (error: any) {
    return error?.response?.data;
  }
};

//#region Account Digital Marketing
export const getCheckDuplicateAccountDigitalMarketing = async (param: TRequestCheckDuplicateMarketingSocial) => {
  try {
    const query = queryString.stringify(param);
    const res = await api.get(`${prefix}/check-duplicate-tkqc?${query}`);
    return res?.data;
  } catch (errors: any) {
    return errors?.response;
  }
};

export const getCheckDuplicateAccountDigitalMarketingById = async (id: number) => {
  try {
    const res = await api.get(`${prefix}/check-duplicate-social-by-id?id=${id}`);
    return res?.data;
  } catch (errors: any) {
    return errors?.response;
  }
};
export const getCommonSettings=async():Promise< TBaseRequestResponse<CommonSettings>>=>{
  try {
    const res = await api.get<TBaseRequestResponse<CommonSettings>>(`${prefix}/common-settings`);
    return res.data;
  } catch (errors: any) {
    return {succeeded:false,error:{message:errors}} as TBaseRequestResponse<CommonSettings>
  }
}
export const saveCommonSettings=async(settings:TCommonSettingsRequest):Promise< TBaseRequestResponse<boolean>>=>{
  try {
    const res = await api.post(`${prefix}/common-settings`,settings);
    return res?.data as TBaseRequestResponse<boolean>;
  } catch (errors: any) {
    return {succeeded:false,error:{message:errors}} as TBaseRequestResponse<boolean>
  }
}
export const getCurrencyRate=async():Promise< TBaseRequestResponse<TCurrencyRate[]>>=>{
  try {
    const res = await api.get<TBaseRequestResponse<TCurrencyRate[]>>(`${prefix}/currency-rates`);
    return res.data;
  } catch (errors: any) {
    return {succeeded:false,error:{message:errors}} as TBaseRequestResponse<TCurrencyRate[]>
  }
}
export const getCurrencyRateFromSource=async():Promise< TBaseRequestResponse<TCurrencyRate[]>>=>{
  try {
    const res = await api.get<TBaseRequestResponse<TCurrencyRate[]>>(`${prefix}/currency-rates-source?source=VCB`);
    return res.data;
  } catch (errors: any) {
    return {succeeded:false,error:{message:errors}} as TBaseRequestResponse<TCurrencyRate[]>
  }
}
export const saveCurrencyRate=async(settings:{currencyRates:TCurrencyRate[]}):Promise< TBaseRequestResponse<boolean>>=>{
  try {
    const res = await api.post(`${prefix}/save-currency-rates`,settings);
    return res?.data as TBaseRequestResponse<boolean>;
  } catch (errors: any) {
    return {succeeded:false,error:{message:errors}} as TBaseRequestResponse<boolean>
  }
}
//#endregion
